<template>
    <section class="draw-attendance__wrapper">
        <div class="draw-attendance-btn" @click="emit('toggle-draw-attendance-popup')">
            <span>Účast v losování:</span>
            <span class="draw-attendance__bold">{{ drawsTotalCount }}x</span>
        </div>
        <TransitionFade>
            <section v-show="drawAttendancePopupVisible" class="draw-attendance-popup">
                <p
                    v-for="(drawText, index) in drawsText"
                    :key="index"
                    class="draw-attendance-popup__text"
                    v-html="drawText"
                ></p>

                <div class="btn draw-attendance-popup__btn" @click="emit('open-popup-banners-modal')">
                    Zvyšte svou šanci na výhru
                </div>
            </section>
        </TransitionFade>
    </section>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import TransitionFade from "@sazka/design-system/src/transitions/transition-fade.vue";
import { PlayerAccountStatusDrawDto } from "@/api-connector/ls-admin-public/models/player-api-models";

const emit = defineEmits(["open-popup-banners-modal", "toggle-draw-attendance-popup"]);

const props = defineProps<{
    drawAttendancePopupVisible: boolean;
    draws?: PlayerAccountStatusDrawDto[];
}>();

const drawTextMaxIndex = computed(() => props.draws?.length - 1 || 0);

const drawsText = computed(() => {
    if (!props.draws || !props.draws.length) {
        return ["Nyní se neúčastníte <strong>žádného losování</strong>"];
    }

    return props.draws.map(
        (drawStatus, index) =>
            `${drawStatus.name} se zúčastníte <strong>${drawStatus.count}x</strong>${
                index != drawTextMaxIndex.value ? "," : ""
            }`
    );
});

const drawsTotalCount = computed(
    () => props.draws?.map((drawStatus) => drawStatus.count).reduce((acc, count) => acc + count, 0) ?? 0
);
</script>
